import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export const usePutCustomerSenderStatus = (
    successCallback?: () => void,
): UseMutationResult<null, Error, { id: number; senderId: number }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { id: number; senderId: number }>({
        mutationFn: async ({ id, senderId }: { id: number; senderId: number }) => {
            const response = await axios.put(
                `${enum_api_uri.put_customer_sender_status.replace(":customer_idx", id.toString()).replace(":sender_idx", senderId.toString())}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerSender"] });
            successCallback?.();
        },
    });
};
